import cx from 'classnames'
import moment from 'moment'

import { UrgentIcon } from '../../../../assets/svgs/components'
import { findDiff as findDiffFunc } from '../../utils'

import styles from './action.module.scss'

export function ActionDetails ({ action, variableParams, lists, editable, setEditableAction }) {
  const findDiff = key => findDiffFunc(action, key)

  const dueDate = moment(new Date(variableParams.dueDate)).format('MM/DD/YYYY')
  const status =
      lists.status.find(l => l.id === variableParams?.status)?.name ||
      'Unknown'
  const assignee = lists.assignee.find(l => l.id === variableParams?.assignee)?.name ||
      'Unknown'

  const setUrgentColor = () => {
    if (variableParams.urgent) {
      return '#FF5741'
    }
    if (Object.prototype.hasOwnProperty.call(action?.diff ?? {}, 'urgent')) {
      return '#b1b1b1'
    }
    return editable ? '#9a9797' : ''
  }

  return (
    <>
      <button
        className={cx(styles.assignee, styles.content)}
        onClick={setEditableAction}
      >
        <span className={cx(styles.assignee, { [styles.modified]: findDiff('assignee') })}>{assignee}</span>
      </button>
      <button
        className={cx(styles.status, styles.content)}
        onClick={setEditableAction}
      >
        <span
          className={cx({
            [styles.modified]: findDiff('status'),
            [styles[status.toLowerCase()]]: findDiff('status') && !action.draft
          })}
        >
          {status}
        </span>
      </button>
      <button
        className={styles.daysAction}
        onClick={setEditableAction}
      >
        <span className={cx(styles.content, { [styles.modified]: findDiff('dueDate') })}>{dueDate}</span>
        <button
          className={cx(styles.urgent, styles.content, {
            [styles.modified]: Object.prototype.hasOwnProperty.call(action?.diff ?? {}, 'urgent')
          })}
          style={{
            padding: '3px 0',
            borderRadius: '8px'
          }}
        >
          <UrgentIcon fill={setUrgentColor()} />
        </button>
      </button>
    </>
  )
}
